import { UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CmsUrlPipe, NavHeaderRepository } from '@usana/ux/cms';
import { AppLinkDirective } from '../../modules/common/app-link.directive';
import { UserService } from '../../modules/common/user.service';
import { CmsTypeGuard } from '../cms-type.guard';
import { DotcomTranslateService } from '../dotcom-translate/dotcom-translate.service';
import { DotcomNavBase } from './dotcom-nav-base';
import { ShopNavFullMenuComponent } from './shop-nav-full-menu.component';

/**
 * Mobile accordion nav for dotcom routes inside the shopSideNav drawer.
 * Mirrors DotcomNavMenuComponent's data loading but renders as an accordion
 * for CMS markets (collapsible sections) and a flat link list for non-CMS markets.
 *
 * Replaces the cart-style category accordion when isDotcomRoute is true.
 * The login/locale bottom section of the drawer is left untouched.
 */
@Component({
    selector: 'dotcom-mobile-nav-menu',
    templateUrl: './dotcom-mobile-nav-menu.component.html',
    styleUrls: ['./dotcom-mobile-nav-menu.component.scss'],
    standalone: true,
    imports: [UpperCasePipe, CmsUrlPipe, AppLinkDirective, ShopNavFullMenuComponent],
})
export class DotcomMobileNavMenuComponent extends DotcomNavBase {

    @Output() closeSideMenu = new EventEmitter<void>();

    /** Index of the currently open accordion section (null = all closed; -1 = Shop sub-nav). */
    activeIndex: number | null = null;

    constructor(
        dotcomTranslateService: DotcomTranslateService,
        userService: UserService,
        cmsTypeGuard: CmsTypeGuard,
        router: Router,
        navHeaderRepository: NavHeaderRepository,
    ) {
        super(dotcomTranslateService, userService, cmsTypeGuard, router, navHeaderRepository);
    }

    toggleSection(index: number): void {
        this.activeIndex = this.activeIndex === index ? null : index;
    }

    navigate(): void {
        this.activeIndex = null;
        this.closeSideMenu.emit();
    }
}
